import httpClient from "@/api/httpClient";

const ONBOARDING = "/api/onboarding";

const getListContent = () => httpClient.get(ONBOARDING + "/content");
const getCaption = () => httpClient.get(ONBOARDING + "/caption");
const postCaption = payload => httpClient.post(ONBOARDING + "/caption", payload);

export { getListContent, getCaption, postCaption };
